import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
const PanelRow = forwardRef((_ref, ref) => {
  let {
    className,
    children
  } = _ref;
  return createElement("div", {
    className: classnames('components-panel__row', className),
    ref: ref
  }, children);
});
export default PanelRow;
//# sourceMappingURL=row.js.map